/**
 * Car Selection Utility
 * Global utility for managing car filter selection (year/make/model)
 * Uses sessionStorage for persistence until browser close
 * Uses window.selectedVehicle as in-memory cache
 */

window.CarSelection = {
  storageKey: 'carFilter_selection',

  /**
   * Get current car selection
   * Priority: window.selectedVehicle (memory cache) → sessionStorage → null
   * @returns {Object|null} Selection object with year, make, model or null
   */
  get: function () {
    // Check if already in memory (avoid JSON.parse)
    if (window.selectedVehicle) {
      return window.selectedVehicle;
    }

    // Load from sessionStorage and cache in window
    try {
      const stored = sessionStorage.getItem(this.storageKey);
      if (stored) {
        window.selectedVehicle = JSON.parse(stored);
        return window.selectedVehicle;
      }
    } catch (error) {
      console.warn('[CarSelection] Failed to load from sessionStorage:', error);
    }

    return null;
  },

  /**
   * Save car selection to sessionStorage and memory cache
   * @param {Object} selection - Selection object with year, make, model
   */
  set: function (selection) {
    if (!selection || !selection.year || !selection.make || !selection.model) {
      console.warn('[CarSelection] Invalid selection object:', selection);
      return;
    }

    try {
      window.selectedVehicle = selection;
      sessionStorage.setItem(this.storageKey, JSON.stringify(selection));
    } catch (error) {
      console.warn('[CarSelection] Failed to save to sessionStorage:', error);
    }
  },

  /**
   * Clear car selection from both sessionStorage and memory cache
   */
  clear: function () {
    try {
      delete window.selectedVehicle;
      sessionStorage.removeItem(this.storageKey);
    } catch (error) {
      console.warn('[CarSelection] Failed to clear selection:', error);
    }
  },

  /**
   * Check if there is a saved selection
   * @returns {boolean}
   */
  hasSelection: function () {
    return this.get() !== null;
  },
};
